export default __webpack_public_path__ + "static/media/compass.089f1cd0.svg";